/* eslint-disable react/jsx-no-bind */
import clsx from 'clsx'
import { CSSProperties, useState } from 'react'
import { useScrollHeight } from 'shared-components/hooks/use-scroll-height'
import { useTocMonitoring } from 'shared-components/hooks/use-toc-monitoring'
import { BasicStyledComponent, DSPageSections } from 'shared-definitions/types'
import ArrowIcon from 'shared-svg/ArrowRightBird.svg'
import TocIcon from 'shared-svg/TableOfContents.svg'
import styles from './TableOfContent.module.css'
import TocMenu from './TocMenu'

interface TableOfContentProps extends BasicStyledComponent {
  variant: 'sm' | 'lg' | 'top'
  sections: DSPageSections
}

const TableOfContents: React.VFC<TableOfContentProps> = ({ sections, variant, className }) => {
  const [opened, setOpened] = useState(variant === 'lg')
  const { ref, height } = useScrollHeight<HTMLDivElement>()
  const { current } = useTocMonitoring(sections ? sections.items : [])

  if (!sections || !sections.items.length) {
    return null
  }

  const Icon = variant === 'top' ? ArrowIcon : TocIcon

  return (
    <div
      ref={ref}
      style={{ '--scroll-height': `${height}px` } as CSSProperties}
      className={clsx(styles.container, className, {
        [styles.containerOpened]: opened,
        [styles.variantLg]: variant === 'lg',
        [styles.variantSm]: variant === 'sm',
        [styles.variantTop]: variant === 'top',
      })}
    >
      <button
        data-sel={opened ? 'collapse-toc' : 'expand-toc'}
        className={styles.titleSection}
        type="button"
        onClick={() => setOpened(s => !s)}
      >
        <div className={styles.title}>{sections.title}</div>
        <div className={styles.titleSelected}>{current?.label}</div>
        <div className={styles.titleIconContainer}>
          <Icon className={styles.titleIcon} />
        </div>
      </button>

      <div className={styles.menu}>
        <div className={clsx(styles.subMenuContainer)}>
          <TocMenu
            currentSection={current}
            sectionItems={sections.items}
            onMenuItemClick={() => {
              setOpened(false)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default TableOfContents
